var _defs, _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRzKurzHellClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 351.07 103.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #ddfb70;\n      }\n\n      .st2 {\n        fill: url(#Unbenannter_Verlauf_69);\n      }\n\n      .st3 {\n        fill: url(#Unbenannter_Verlauf_57);\n      }\n\n      .st4 {\n        fill: url(#Unbenannter_Verlauf_50);\n      }\n\n      .st5 {\n        fill: url(#Unbenannter_Verlauf_53);\n      }\n\n      .st6 {\n        fill: url(#Unbenannter_Verlauf_77);\n      }\n\n      .st7 {\n        fill: url(#Unbenannter_Verlauf_74);\n      }\n\n      .st8 {\n        fill: url(#Unbenannter_Verlauf_70);\n      }\n\n      .st9 {\n        fill: url(#Unbenannter_Verlauf_71);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_69",
    "data-name": "Unbenannter Verlauf 69",
    x1: 202.75,
    y1: 25.03,
    x2: 225.62,
    y2: 58.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#9baab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#667f8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#476675"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_70",
    "data-name": "Unbenannter Verlauf 70",
    x1: 233.58,
    y1: 18.63,
    x2: 249.92,
    y2: 53.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#9baab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#667f8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476675"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_57",
    "data-name": "Unbenannter Verlauf 57",
    x1: 172.08,
    y1: 25.64,
    x2: 190.77,
    y2: 56.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#9baab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#667f8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476675"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_77",
    "data-name": "Unbenannter Verlauf 77",
    x1: 141.18,
    y1: 20.72,
    x2: 155.43,
    y2: 54.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#9baab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#667f8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476675"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_50",
    "data-name": "Unbenannter Verlauf 50",
    x1: 22.54,
    y1: 33.35,
    x2: 76.27,
    y2: 100.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9baab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#667f8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476675"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_74",
    "data-name": "Unbenannter Verlauf 74",
    x1: 71.24,
    y1: 22.04,
    x2: 76.56,
    y2: 29.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#9baab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#667f8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476675"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_53",
    "data-name": "Unbenannter Verlauf 53",
    x1: 25.27,
    y1: 69.41,
    x2: 48.56,
    y2: 103.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9baab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#667f8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#476675"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_71",
    "data-name": "Unbenannter Verlauf 71",
    x1: 109.46,
    y1: 26.48,
    x2: 126.06,
    y2: 55.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9baab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#667f8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#476675"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 311.1,
    y: 87.97,
    width: 1.89,
    height: 1.52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.09,90.49c-1.14,0-2.03.31-2.67.93-.64.62-.97,1.52-.97,2.71v.95c0,1.2.32,2.11.97,2.74.65.62,1.54.94,2.67.94s2.01-.31,2.65-.94c.64-.63.96-1.54.96-2.74v-.95c0-1.18-.32-2.08-.96-2.7-.64-.62-1.52-.94-2.65-.94M321.81,95.07c0,1.32-.57,1.98-1.72,1.98s-1.75-.66-1.75-1.98v-.91c0-1.32.58-1.98,1.75-1.98.55,0,.98.16,1.28.48.3.32.44.82.44,1.5v.91Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 311.1,
    y: 90.63,
    width: 1.89,
    height: 7.99
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.03,88.4l-1.89.66v1.57h-1.4v1.34h1.4v4.19c0,.79.22,1.39.65,1.82.43.43,1.05.64,1.86.64h1.03v-1.61h-.68c-.35,0-.6-.07-.74-.22-.15-.15-.22-.4-.22-.74v-4.07h1.81v-1.34h-1.81v-2.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.72,94.57c-.44-.38-1.12-.63-2.04-.73l-1.27-.15c-.41-.04-.7-.13-.88-.26-.17-.13-.26-.31-.26-.54,0-.28.13-.49.38-.64.25-.15.64-.22,1.16-.22.55,0,.97.08,1.25.25.28.16.41.4.41.71v.05h1.77v-.06c0-.76-.3-1.35-.91-1.78-.6-.43-1.44-.65-2.5-.65s-1.85.22-2.44.65c-.6.43-.89,1.04-.89,1.83,0,.67.21,1.2.64,1.56.43.36,1.09.6,1.99.72l1.18.14c.45.05.78.14.98.28.2.13.3.32.3.57,0,.3-.14.52-.42.68-.28.15-.69.23-1.24.23-.58,0-1.03-.09-1.32-.28-.3-.18-.45-.44-.45-.75v-.03h-1.78v.05c0,.81.3,1.44.91,1.88.61.45,1.45.67,2.54.67s1.98-.22,2.62-.66c.64-.44.96-1.08.96-1.91,0-.67-.22-1.19-.66-1.57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.17,78.5c0-.67.17-1.18.5-1.53.33-.35.8-.53,1.41-.53.41,0,.79.07,1.14.2v-1.81c-.2-.04-.46-.06-.75-.06-.48,0-.93.09-1.33.27-.41.18-.74.45-1.01.81v-.91h-1.86v7.99h1.91v-4.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.21,74.8c-1.15,0-2.05.33-2.7.98-.66.65-.98,1.58-.98,2.8v.69c0,1.24.34,2.18,1.01,2.83.67.65,1.6.97,2.77.97,1.03,0,1.87-.23,2.5-.7.63-.47.97-1.08,1.02-1.85v-.09h-1.86v.05c-.06.3-.22.53-.5.69s-.64.25-1.08.25c-1.31,0-1.97-.64-1.97-1.92v-.03h5.48v-.92c0-1.2-.33-2.12-.98-2.77-.66-.65-1.56-.97-2.7-.97M323,78.15h-3.58c.07-1.15.67-1.72,1.8-1.72.54,0,.97.14,1.3.41.32.27.48.67.48,1.21v.11Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M331.27,90.54c-.47,0-.91.08-1.31.25-.4.16-.75.4-1.04.71v-.86h-1.86v7.99h1.9v-4.52c0-.62.15-1.09.46-1.41.31-.31.73-.47,1.28-.47,1.06,0,1.58.6,1.58,1.8v4.59h1.9v-4.98c0-.97-.26-1.73-.77-2.28-.51-.55-1.23-.82-2.15-.82"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.81,72.71l-1.89.66v1.57h-1.4v1.34h1.4v4.19c0,.79.22,1.39.65,1.82.43.43,1.05.64,1.86.64h1.03v-1.61h-.68c-.35,0-.6-.07-.74-.22-.15-.15-.22-.4-.22-.74v-4.07h1.81v-1.34h-1.81v-2.23Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.04,90.49c-1.14,0-2.03.31-2.67.93-.65.62-.97,1.52-.97,2.71v.95c0,1.2.32,2.11.97,2.74.64.62,1.54.94,2.67.94s2.01-.31,2.65-.94c.64-.63.96-1.54.96-2.74v-.95c0-1.18-.32-2.08-.96-2.7-.64-.62-1.52-.94-2.65-.94M280.76,95.07c0,1.32-.57,1.98-1.72,1.98s-1.75-.66-1.75-1.98v-.91c0-1.32.58-1.98,1.75-1.98.55,0,.98.16,1.27.48.3.32.45.82.45,1.5v.91Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.98,78.5c0-.67.17-1.18.5-1.53.33-.35.8-.53,1.41-.53.41,0,.79.07,1.14.2v-1.81c-.2-.04-.46-.06-.75-.06-.48,0-.93.09-1.33.27-.4.18-.74.45-1.01.81v-.91h-1.86v7.99h1.91v-4.42Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.33,82.92h1.91v-4.98c0-.97-.27-1.73-.82-2.28-.54-.55-1.3-.82-2.29-.82-1.03,0-1.89.36-2.57,1.08-.27-.36-.6-.63-1-.81-.4-.18-.84-.27-1.32-.27-.43,0-.85.08-1.25.25-.4.16-.74.4-1.01.71v-.86h-1.86v7.99h1.9v-4.52c0-.6.15-1.07.44-1.39.29-.32.7-.48,1.24-.48.49,0,.87.14,1.13.43.26.29.39.72.39,1.29v4.67h1.9v-4.55c0-.58.15-1.04.44-1.36.29-.32.7-.48,1.22-.48s.88.15,1.14.45c.26.3.39.75.39,1.34v4.59Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.65,93.84l-1.27-.15c-.41-.04-.7-.13-.88-.26-.18-.13-.26-.31-.26-.54,0-.28.13-.49.38-.64.25-.15.64-.22,1.16-.22.55,0,.97.08,1.24.25.28.16.42.4.42.71v.05h1.77v-.06c0-.76-.3-1.35-.91-1.78-.6-.43-1.44-.65-2.5-.65s-1.85.22-2.44.65c-.59.43-.89,1.04-.89,1.83,0,.68.21,1.2.64,1.56.42.36,1.09.6,1.99.72l1.18.14c.45.05.78.14.98.28.2.13.3.32.3.57,0,.3-.14.52-.42.68-.28.15-.69.23-1.24.23-.58,0-1.02-.09-1.32-.28-.3-.18-.45-.43-.45-.75v-.03h-1.78v.05c0,.81.3,1.44.91,1.88.61.45,1.45.67,2.54.67s1.98-.22,2.62-.66c.64-.44.96-1.08.96-1.9,0-.67-.22-1.19-.66-1.58-.44-.38-1.12-.63-2.04-.73"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.26,78.15l-1.27-.15c-.41-.04-.7-.13-.88-.26-.17-.13-.26-.31-.26-.54,0-.28.13-.49.38-.64.25-.15.64-.22,1.16-.22.55,0,.97.08,1.24.25.28.16.42.4.42.71v.05h1.77v-.06c0-.76-.3-1.35-.91-1.78-.61-.43-1.44-.65-2.51-.65s-1.85.22-2.44.65c-.59.43-.89,1.04-.89,1.83,0,.68.21,1.2.64,1.56.43.36,1.09.6,1.99.72l1.18.14c.45.05.78.14.97.28.2.13.3.32.3.57,0,.3-.14.52-.42.68-.28.15-.69.23-1.24.23-.58,0-1.02-.09-1.32-.28-.3-.18-.45-.43-.45-.75v-.03h-1.78v.05c0,.81.3,1.44.91,1.88.6.45,1.45.67,2.53.67s1.98-.22,2.62-.66c.64-.44.96-1.08.96-1.9,0-.67-.22-1.19-.66-1.58-.44-.38-1.12-.63-2.04-.73"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M288.16,96.74c-.16-.16-.24-.43-.24-.82v-7.9h-1.9v8.02c0,.87.22,1.52.65,1.94.43.42,1.1.64,2,.64h1.06v-1.64h-.72c-.41,0-.69-.08-.85-.24"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.86,95.18c0,.62-.13,1.09-.38,1.41-.26.31-.68.47-1.27.47s-1.01-.16-1.27-.48c-.26-.32-.39-.78-.39-1.4v-4.55h-1.9v4.64c0,1.15.3,2.02.9,2.6.6.59,1.49.88,2.67.88s2.07-.29,2.67-.88c.6-.58.9-1.45.9-2.61v-4.64h-1.91v4.55Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.71,82.83c.36-.13.7-.34,1.01-.64v.74h1.84v-5.1c0-.96-.31-1.7-.91-2.21-.61-.51-1.48-.77-2.62-.77-1.01,0-1.82.22-2.42.65-.6.44-.9,1.03-.9,1.79v.05h1.81v-.05c0-.29.12-.52.34-.71.23-.18.6-.28,1.11-.28,1.13,0,1.69.48,1.69,1.43v.48h-2.14c-.99,0-1.75.2-2.28.6-.53.4-.79.98-.79,1.74s.25,1.4.74,1.83c.5.43,1.23.65,2.19.65.51,0,.95-.06,1.31-.19M293.32,80.5c0-.34.13-.59.38-.75.26-.16.66-.24,1.2-.24h1.78v.49c0,.99-.62,1.49-1.86,1.49-.5,0-.88-.09-1.13-.26-.25-.17-.38-.42-.38-.74"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.28,70.62v-2.79c0-1.83.28-3.1,1-3.92.72-.82,1.85-1.14,3.46-1.14h9.56v-4.13h-9.34c-3.1,0-5.45.79-7.02,2.31-1.57,1.52-2.39,3.78-2.39,6.77v2.9h-3.29v4.13h3.29v22.62h4.74v-22.62h6.61l1.09-2.94v-1.19h-7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.05,70.05l-13.7.07h0c-.11,0-.22,0-.32,0-1.15,0-2.02.3-2.61.87-.66.64-1.01,1.65-1.01,3.03v23.77h4.79v-23.53l12.86-.07v-4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.84,70.1c-8.66,0-14.35,6.03-14.36,14.03,0,8.06,5.7,14.08,14.36,14.08,8.6,0,14.3-6.03,14.3-14.08,0-8-5.7-14.02-14.3-14.03ZM222.05,91.3c-1.65,1.85-4.09,2.98-7.22,2.98-3.16,0-5.47-1.14-6.99-2.99-1.52-1.85-2.23-4.38-2.23-7.18s.72-5.29,2.23-7.13c1.52-1.84,3.83-2.98,6.99-2.98,3.13,0,5.57,1.14,7.22,2.98,1.65,1.84,2.51,4.36,2.51,7.13s-.86,5.34-2.51,7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.23,93.79v-19.23h7.19l.95-2.82v-1.1h-8.14v-8.83h-4.63v8.83h-10.24v5.38l-14.56,7.65v-21.9h-4.63v35.88h4.63v-9.39l6.09-3.21,9.13,12.6h4.52v-1.05s-9.82-13.57-9.82-13.57l6.87-3.63h0c1.44-.7,2.17-1.85,2.18-3.46h0s.04-1.39.04-1.39h5.79v19.38c0,1.3.31,2.22.92,2.82.61.6,1.53.9,2.8.9h10.14v-1.07s-1-2.85-1-2.85l-8.22.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.2,74.29l.86,3.38h-1.62l-.03-.09c-1.2-4.18-4.7-7.47-10.91-7.48-7.88,0-12.81,6.01-12.82,14.03,0,8.01,4.94,14.08,12.82,14.08,6.21,0,9.71-3.36,10.91-7.53l.03-.09h1.62l-.86,3.43v3.65h4.58v-27.01h-4.58v3.65ZM141.22,91.87c-1.85,1.66-4.39,2.42-7.18,2.42-2.79,0-5.23-.76-6.96-2.42-1.74-1.66-2.76-4.21-2.76-7.74,0-3.53,1.02-6.07,2.76-7.71,1.74-1.65,4.17-2.39,6.96-2.39s5.33.75,7.18,2.39c1.85,1.64,2.98,4.18,2.98,7.72,0,3.54-1.14,6.09-2.98,7.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.65,23.78c-5.81,0-9.21,3.89-10.35,8.79l-.02.1h-2.63l1.86-5.36v-13.85h-.88s-8.25,4.56-8.25,4.56v33.82h9.13v-9.86c0-3.94.76-6.48,2.11-8.04,1.36-1.57,3.31-2.12,5.63-2.12,2.1,0,3.52.46,4.4,1.58.88,1.12,1.21,2.84,1.21,5.35v13.1h9.24v-14.58c0-4.34-1.09-7.71-3.06-9.99-1.97-2.28-4.82-3.49-8.39-3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M252.39,43.8h-4.61v-25.88c0-1.49-.42-2.6-1.19-3.35-.77-.75-1.92-1.14-3.4-1.14h-4.92l-9.17,7.48-.02.5h9.52v22.38h-4.47v8.03h18.26v-8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M172.6,52.38c6.87,0,9.26-3.45,10.69-7.05l.03-.08h2.62l-1.86,5.41v1.17h9.13v-27.51h-9.13v1.17l1.86,5.36h-2.62l-.03-.08c-1.43-3.54-3.83-6.99-10.69-7-4.02,0-6.97,1.64-8.92,4.24-1.95,2.6-2.91,6.16-2.91,10.01,0,3.87.96,7.47,2.91,10.09,1.96,2.62,4.9,4.27,8.92,4.27ZM171.72,33.28c1.21-1.01,3-1.47,5.32-1.47,2.32,0,4.08.45,5.27,1.47,1.19,1.02,1.77,2.58,1.77,4.74,0,2.21-.58,3.81-1.77,4.84-1.19,1.03-2.95,1.48-5.27,1.48s-4.11-.47-5.32-1.5c-1.21-1.04-1.83-2.63-1.83-4.82,0-2.16.61-3.73,1.83-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M137.02,47.13c0,1.54.42,2.71,1.2,3.5s1.94,1.2,3.45,1.2h16.58v-1.23s-2.31-6.81-2.31-6.81l-9.79.06v-10.79h9.74l2.49-7.44v-1.29h-12.23v-10.87h-1.01s-8.13,4.63-8.13,4.63v6.25h-3.91v8.73h3.91v14.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.59,91.14c-1.85,0-3.35,1.5-3.36,3.36,0,1.85,1.5,3.35,3.36,3.36,1.85,0,3.35-1.5,3.36-3.36,0-1.85-1.5-3.35-3.36-3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M79.67,32.79l-11.91,3.82h-.06s-.15-.06-.15-.06l-.06-.15v-.08c.26-.79,1.42-4.58,1.5-4.84.03-.09.04-.16.04-.21,0-.08-.02-.11-.13-.22-.12-.12-3.97-3.67-5.89-5.43-.64-.59-1.06-.98-1.06-.98-.11-.1-.16-.24-.16-.37,0-.1.02-.19.06-.28h0s0-.02,0-.02c1.05-1.49,1.75-2.53,2.61-3.78.1-.13.22-.33.38-.42l.2-.05c.17,0,.35.06.55.1,2.97.63,6.2,1.32,9.17,1.93.23.05,1.13.24,1.39.3.09-.13.28-.44.5-.79l-.04-.05c-.06-.07-.14-.17-.25-.29-.22-.25-.53-.61-.93-1.05-.78-.88-1.87-2.09-3.09-3.42-2.44-2.66-5.4-5.83-7.49-7.92-.5-.5-1.9-1.37-3.57-1.37-1.16,0-2.46.41-3.72,1.67-4.2,4.2-32.95,35.12-47.9,50.29-.17.17-.5.81-.76,1.6-.26.79-.48,1.74-.48,2.58,0,.48.07.93.24,1.28.7,1.49,2.2,3.83,3.59,5.92,1.39,2.09,2.68,3.93,2.98,4.47l.08.19v.13c0,1.42-1.23,6.61-2.47,11.48-1.21,4.77-2.42,9.2-2.47,9.37v1.81h24.32l-2.7-4.96-6.2-2.19,20.79-19.43-6.75-21.55.53-.94,21.89,43.23-2.29.18-2.13-3.11-7.05,1,3.98,7.85,16.88-.07c.06-.42.28-2.14.6-4.59.37-2.83.86-6.63,1.34-10.49.98-7.71,1.95-15.69,1.95-16.64v-.05c-5.63-9.84-18.66-30.32-21.83-35.28-.45-.71-.7-1.1-.71-1.1l-.04-.07.04-.07.41-.62,12.54,14.89,8.58-.03c.09-.17.39-.73.81-1.5.51-.94,1.19-2.2,1.88-3.48,1.38-2.55,2.78-5.15,2.88-5.36l.03-.16-.04-.12c-.12-.14-.36-.38-.46-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M74.68,28.5c.17.13.28.21.42.21.27-.02,1.74-.07,2.19-.08l-.61-3.22-6.74-.71,4.74,3.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "33.36 88.97 37.17 97.65 48.6 97.62 41.42 81.92 33.36 88.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M120,45.52c-.63.33-1.58.48-2.93.48-1.93,0-3.33-.3-4.26-.97-.9-.65-1.32-1.65-1.34-2.98h-9.19c.03,3.42,1.25,5.98,3.65,7.7,2.43,1.75,6.08,2.64,10.92,2.64,4.51,0,7.84-.75,10.02-2.16,2.18-1.41,3.24-3.45,3.24-6.11,0-2.63-1.04-4.45-2.62-5.76-1.59-1.31-3.74-2.1-5.95-2.62l-6.47-1.54c-.89-.22-1.59-.5-2.07-.86-.49-.36-.76-.81-.76-1.35,0-.62.34-1.12.94-1.42.61-.31,1.47-.46,2.58-.46,1.62,0,2.8.11,3.6.54.78.42,1.15,1.17,1.17,2.32h9.14c-.04-3.27-1.36-5.54-3.73-7.02-2.41-1.5-5.91-2.18-10.23-2.18-3.96,0-7.12.71-9.28,2.08-2.16,1.37-3.32,3.37-3.32,6.02,0,2.43.99,4.15,2.36,5.37,1.36,1.22,3.1,1.92,4.57,2.3l8.72,2.36c.72.19,1.26.45,1.63.78.37.34.55.76.55,1.26,0,.69-.29,1.24-.92,1.56Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRzKurzHellClaim);
export default __webpack_public_path__ + "static/media/Logo_RZ_kurz_hell_ claim.f8e968c0650dee37c1f56972a9ae91f0.svg";
export { ForwardRef as ReactComponent };